import React from 'react';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';

// Services
import API from 'API';

// Components
import Loader from 'components/common/Loader';

//-----------------------------------------------------------------

class EditCondemnNotesModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    open(opt) {
        return new Promise((resolve) => {
            this.resolve = resolve;
            this.setState({
                isOpen: true,
                isChanged: false,
                id: opt.id,
                condemnDate: opt.condemnDate,
                condemnNotes: opt.condemnNotes
            });
        });
    }

    close() {
        this.setState({ isOpen: false });
    }

    async confirmUncondemn() {
        const confirm = window.confirm('Are you sure you want to un-mark this chimney as condemned? (This will not affect past certificates)');
        if (confirm) {
            this.setState({ isLoading: true });
            await API.call('property/uncondemn-chimney/' + this.state.id);
            this.close();
            this.resolve({ action: 'uncondemn' });
        }
    }

    render() {
        const { 
            isOpen
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (
            <Modal show onHide={() => this.close()} className="editenotes-modal" backdrop="static" keyboard={false}>
                <Modal.Body>

                    {this.renderInner()}

                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => this.close()}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }

    renderInner() {
        const { isLoading, condemnDate, condemnNotes } = this.state;
        if (isLoading) {
            return (<Loader />);
        }

        return (<>

            <div className="form-group mb-3">
                <label className="form-label">Date Condemned</label>
                <p className="form-control-plaintext">
                    {moment(condemnDate).format('DD/MM/YYYY')}
                </p>
            </div>

            <div className="form-group">
                <label className="form-label">Condemn Notes</label>
                <div className="form-control-plaintext">
                    {(condemnNotes || '').split(/\r\n|\r|\n/).map((l, i) =>
                        <div key={i}>
                            {l}
                        </div>
                    )}
                </div>
            </div>

            <hr />

            <button type="button" className="btn btn-danger mt-3" onClick={() => this.confirmUncondemn()}>
                Un-mark as Condemned
            </button>

        </>);
    }
}

export default EditCondemnNotesModal;